export default function HeroSection() {
  const handleNavClick = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    e.preventDefault();
    const el = document.querySelector(href);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section
      id="hero"
      className="relative min-h-screen flex items-center pt-[72px] overflow-hidden"
    >
      <div className="absolute inset-0 bg-gradient-to-br from-primary-50/60 via-background-50 to-accent-50/40"></div>

      <div className="relative w-full px-4 md:px-6 py-10 md:py-14">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16 w-full max-w-[1400px] mx-auto">
          <div className="flex-1 w-full text-center lg:text-left">
            <span className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full bg-accent-100 text-accent-700 text-xs font-medium mb-6">
              <i className="ri-fire-line text-sm"></i>
              每日更新 · 全本免费
            </span>

            <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-extrabold text-foreground-950 leading-tight text-balance mb-5">
              亲亲漫画网 · 海量免费漫画在线下拉式阅读平台
            </h1>

            <p className="text-lg md:text-xl text-foreground-600 font-medium mb-4">
              韩漫日漫国漫全本完整版，追更全在这里
            </p>

            <p className="text-sm md:text-base text-foreground-500 leading-relaxed max-w-2xl mx-auto lg:mx-0 mb-8">
              亲亲漫画网汇聚全网热门漫画资源，涵盖韩漫、日漫、国漫等多元品类。采用流畅下拉式阅读体验，免去翻页等待，沉浸式畅享每一话精彩剧情。全本完整版实时追更，每日更新不断档，无论你是热血少年、浪漫少女还是都市悬疑爱好者，都能在这里找到属于你的漫画世界。
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-6 mb-8">
              <div className="flex items-center gap-2">
                <div className="w-8 h-8 flex items-center justify-center rounded-full bg-primary-100">
                  <i className="ri-book-2-line text-primary-600 text-sm"></i>
                </div>
                <span className="text-sm text-foreground-600">日更 <strong className="text-primary-600">200+</strong> 话</span>
              </div>
              <div className="flex items-center gap-2">
                <div className="w-8 h-8 flex items-center justify-center rounded-full bg-accent-100">
                  <i className="ri-group-line text-accent-600 text-sm"></i>
                </div>
                <span className="text-sm text-foreground-600">覆盖 <strong className="text-accent-600">10万+</strong> 部作品</span>
              </div>
              <div className="flex items-center gap-2">
                <div className="w-8 h-8 flex items-center justify-center rounded-full bg-secondary-100">
                  <i className="ri-shield-check-line text-secondary-600 text-sm"></i>
                </div>
                <span className="text-sm text-foreground-600">完全免费 · 无需注册</span>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#carousel"
                onClick={(e) => handleNavClick(e, '#carousel')}
                className="inline-flex items-center gap-2 px-7 py-3.5 bg-primary-500 text-background-50 font-semibold text-sm rounded-full hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
              >
                <i className="ri-compass-3-line text-base"></i>
                开始探索热门漫画
              </a>
              <a
                href="#ranking"
                onClick={(e) => handleNavClick(e, '#ranking')}
                className="inline-flex items-center gap-2 px-7 py-3.5 bg-background-100 text-foreground-800 font-semibold text-sm rounded-full hover:bg-background-200 transition-colors border border-background-200/70 whitespace-nowrap cursor-pointer"
              >
                <i className="ri-trophy-line text-base"></i>
                查看热门排行榜
              </a>
            </div>
          </div>

          <div className="flex-1 w-full flex justify-center lg:justify-end">
            <div className="relative w-full max-w-[500px] aspect-[4/5] overflow-hidden rounded-2xl bg-background-100">
              <img
                src="https://readdy.ai/api/search-image?query=A%20vibrant%20colorful%20illustration%20of%20various%20manga%20and%20comic%20book%20elements%20floating%20dynamically%2C%20including%20speech%20bubbles%2C%20action%20lines%2C%20character%20silhouettes%20in%20warm%20orange%20and%20coral%20tones%2C%20Japanese%20and%20Korean%20comic%20style%20panels%20layered%20artistically%2C%20soft%20cream%20background%20with%20subtle%20gradient%2C%20modern%20editorial%20composition%2C%20clean%20and%20energetic%20aesthetic&width=1000&height=1250&seq=hero-manga-2026&orientation=portrait"
                alt="亲亲漫画 - 海量免费漫画在线阅读平台主视觉"
                className="w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-background-50/50 via-transparent to-transparent"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}